export const availableLanguages = ["nl", "en"];
